module.exports = __webpack_public_path__ + "img/retirementquote.ea22b83c.png";